import { useState } from "react";
import downArrow from "src/assets/down-arrow.svg";
import receipt from "src/features/fields/assets/receipt.svg";
import check from "src/features/fields/assets/check.svg";
import qrcode from "src/features/fields/assets/qrcode.svg";
import cross from "src/features/fields/assets/cross.svg";
import logo from "src/features/fields/assets/logo.svg";
import { Button, Modal } from "src/components";
import InvoiceAcknowledgement from "../InvoiceAcknowledgement";
import { downloadInvoice } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
import { getInvoiceAcknowledgementFullInfo } from "../../OrderDetailsTab/OrderHelper";

interface OrderInfoInvoiceCard {
  fuid: any;
  summaryData: any[];
  acknowledgementData: any[];
  index: number;
  company_code: string;
}

const OrderInfoInvoiceCard = ({ fuid, summaryData, acknowledgementData, index, company_code }: OrderInfoInvoiceCard) => {
  const [isExpanded, setIsExpanded] = useState(index === 0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const { toast } = useToast();

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalClose2 = () => {
    setIsModalOpen2(false);
  };
  return (
    <div>
      <div className="mt-6 w-full mx-auto shadow-sm border border-[#D0D0D0] rounded-xl p-6 bg-white">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <div className="flex gap-2 items-center">
              <img src={receipt} alt="receipt" className="inline w-6 h-6 transform scale-x-[-1]" />
              <p className="font-semibold text-[1.3rem]">Invoice {fuid?.invoice?.invoice_number}</p>
              <p className="font-semibold flex items-center w-fit text-[.8rem] h-6 px-2 rounded-full bg-[#E3E3E3] text-[#4A4A4A]">
                FUID {fuid?.invoice?.stockistInvoiceAttachment?.fuid_no}
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <Button className="font-normal bg-[#F1F1F1] border shadow-sm border-[#D0D0D0]" onClick={() => setIsModalOpen(true)}>
              View QR code
            </Button>
            <Button
              className="font-normal text-white bg-[#8051FF]"
              onClick={() => {
                if (!fuid?.invoice?.stockistInvoiceAttachment?.file_path) {
                  toast({ description: "Invoice not found", variant: "destructive" });
                  return;
                }

                toast({ title: "Downloading...", description: "Downloading invoice", variant: "default" });

                downloadInvoice(fuid?.invoice?.stockistInvoiceAttachment?.file_path, company_code as string).then((res: any) => {
                  if (res?.data?.success && res?.data?.data) {
                    window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                  } else {
                    console.error("Failed to download the invoice.");
                  }
                });
              }}
            >
              Download
            </Button>
            <Button className="w-10 shadow-sm h-10 bg-[#F1F1F1] border border-[#D0D0D0]" onClick={handleToggle}>
              <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
            </Button>
          </div>
        </div>{" "}
        <div
          className={`transition-all items-center duration-500 ease-in-out ${isExpanded ? "opacity-100 max-h-[1000px]" : "max-h-0 opacity-0"}`}
          style={{ transitionProperty: "max-height, opacity" }}
        >
          <div className="border-t mt-6 border-[#d0d0d0]"></div>
          <p className="mt-4 text-sm font-semibold">Summary</p>
          <div className="grid grid-cols-3 gap-4 mt-4 text-sm">
            {Object.entries(summaryData).map(([key, value], index) => (
              <div key={index} className="flex gap-10 items-center">
                <span className="font-normal text-[#616161]">{key} : </span>
                {key === "IR No." && value?.length > 8 ? (
                  <div className="relative group inline-block">
                    <span className="text-[#303030]">
                      {value.slice(0, 8)}...
                    </span>

                    <div className="absolute left-0 bottom-full mb-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10">
                      {value}
                    </div>
                  </div>
                ) : (
                  <span className="text-[#303030]">{value}</span>
                )}
                {/* <span className="text-[#303030]">{key === "IR No." ? `${value.slice(0, 8)}...` : value}</span> */}
                {/* Conditional rendering for buttons */}
                {key === "IR No." && <img src={check} alt="check" className="w-6 h-6" />}
                {/* {key === "E-Invoice Applicable" && <Button className="font-normal h-7 bg-[#F1F1F1] border shadow-sm border-[#D0D0D0]">Edit</Button>}  */}
                {/* {key === "IR No." && (
                  <Button
                    className="font-normal h-7 bg-[#F1F1F1] border shadow-sm border-[#D0D0D0]"
                    onClick={() => {
                      if (!navigator.clipboard) {
                        toast({ description: "Clipboard API not supported", variant: "destructive" });
                        return;
                      }

                      navigator.clipboard
                        .writeText(String(value))
                        .then(() => {
                          toast({ description: "Copied to clipboard", variant: "default" });
                        })
                        .catch(() => {
                          toast({ description: "Failed to copy", variant: "destructive" });
                        });
                    }}
                  >
                    Copy
                  </Button>
                )} */}
              </div>
            ))}
          </div>
          <div className="bg-[#F3F3F3] mt-4 p-4 rounded-lg">
            <div className="flex justify-between items-center">
              <p className="text-sm font-semibold">Acknowledgement</p>

              <Button className="font-normal h-8 bg-[#F1F1F1] border shadow-sm border-[#D0D0D0]" onClick={() => setIsModalOpen2(true)}>
                Open full view
              </Button>
            </div>
            <div className="border-t mt-4 border-[#d0d0d0]"></div>
            <div className="grid grid-cols-3 gap-4 mt-4 text-sm">
              {Object.entries(acknowledgementData).map(([key, value], index) => (
                <div key={index} className="flex gap-10 items-center">
                  <span className="font-normal text-[#616161]">{key} : </span>
                  <span className="text-[#303030]">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-[-24px]">
        <InvoiceAcknowledgement
          fuid={fuid}
          company_code={company_code}
          invoiceAcknowledgement={getInvoiceAcknowledgementFullInfo(fuid)}
          isOpen={isModalOpen2}
          onClose={handleModalClose2}
        />
        <Modal isOpen={isModalOpen} onCloseModal={handleModalClose} isHeader={false} title="View QR Code">
          <div className="flex flex-col gap-4 p-6">
            <header className="flex justify-between items-center">
              <p>View QR Code</p>
              <img src={cross} alt="cross" onClick={() => handleModalClose()} className="w-5 h-5 invert cursor-pointer" />
            </header>
            <img src={qrcode} alt="check" className="p-4 w-80 h-80" />
            <img src={logo} alt="logo" className="absolute top-[175px] left-[140px] z-10 w-24 h-24" />
            <p className="text-sm text-[#616161]">Invoice No</p>
            <input type="text" className="w-full border border-[#D0D0D0] rounded-md p-2 h-8" value={fuid?.invoice?.invoice_number} />
            <Button onClick={() => handleModalClose()} className="px-4 py-2 w-full text-white rounded-lg bg-[#8051FF]">
              Save Changes
            </Button>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default OrderInfoInvoiceCard;
